"use client";

import { setContext } from "@apollo/client/link/context";

import { extractLocaleFromPathname } from "./extract-locale-from-pathname";

function getCurrentPathname(): string {
  return typeof window !== "undefined" ? window.location.pathname : "/";
}

/**
 * Apollo Client の link で `x-language` ヘッダーを設定する。
 * pathname (例: `/en/checkin`) から locale を抽出し、BE (Yoga) の `caller.locale` 解決に使われる。
 *
 * `getPathname` は test 用に差し替え可能。production では `window.location.pathname` を参照する。
 */
export function createLocaleLink(
  getPathname: () => string = getCurrentPathname,
) {
  return setContext((_operation, prevContext) => {
    const locale = extractLocaleFromPathname(getPathname());
    const prevHeaders =
      (prevContext as { headers?: Record<string, string> }).headers ?? {};
    return {
      headers: {
        ...prevHeaders,
        "x-language": locale,
      },
    };
  });
}

export const localeLink = createLocaleLink();
